import React from 'react';
import { mediaUrl } from '../../../utils/mediaUrl';

const TextMessage = ({ message, avatarSrc }) => {
  const { content, timestamp } = message;
  const avatarUrl = mediaUrl(avatarSrc);

  return (
    <div className="message">
      <img
        className="avatar"
        src={avatarUrl || undefined}
        alt="成員頭像"
        onError={(e) => {
          e.target.onerror = null;
          e.target.removeAttribute('src');
        }}
      />
      <div className="message-content">
        <div className="message-text">
          {content && content.split('\n').map((text, index) => (
            <React.Fragment key={index}>
              {text}
              {index < content.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
        <div className="timestamp">{timestamp}</div>
      </div>
    </div>
  );
};

export default TextMessage;